/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Product owner the selector offers, identified by its Personne.
 * @export
 * @interface ActorReferentialItem
 */
export interface ActorReferentialItem {
    /**
     * Personne id, the one product commands expect as personId and product details return as ownerId.
     * @type {string}
     * @memberof ActorReferentialItem
     */
    id: string;
    /**
     * Legal entity designation, otherwise the account name.
     * @type {string}
     * @memberof ActorReferentialItem
     */
    label: string;
}

/**
 * Check if a given object implements the ActorReferentialItem interface.
 */
export function instanceOfActorReferentialItem(value: object): value is ActorReferentialItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function ActorReferentialItemFromJSON(json: any): ActorReferentialItem {
    return ActorReferentialItemFromJSONTyped(json, false);
}

export function ActorReferentialItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActorReferentialItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
    };
}

export function ActorReferentialItemToJSON(json: any): ActorReferentialItem {
    return ActorReferentialItemToJSONTyped(json, false);
}

export function ActorReferentialItemToJSONTyped(value?: ActorReferentialItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
    };
}

